import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../common/Modal/Modal";
import { Heading } from "../../../common/Heading/Heading";
import { Button } from "../../../common/Button/Button";

export const DeleteInvitationModal = ({
  isOpen,
  onClose,
  onConfirm,
  token,
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    setError(null);

    try {
      await onConfirm();

      onClose();
    } catch (err) {
      setError(t("invitations.failedToDeleteInvitation"));
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <Heading
          text={t("invitations.deleteInvitation")}
          size={2}
          marginBottom="1"
        />
        <p>
          {t("invitations.deleteInvitationConfirm")} <strong>{token}</strong>?
        </p>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <ButtonsContainer>
          <Button
            text={t("common.cancel")}
            onClick={onClose}
            variant="white"
            disabled={isDeleting}
          />
          <Button
            text={isDeleting ? t("common.deleting") : t("common.delete")}
            onClick={handleDelete}
            variant="red"
            marginBottom="0"
            disabled={isDeleting}
          />
        </ButtonsContainer>
      </ModalContent>
    </Modal>
  );
};

const ModalContent = styled.div`
  padding: 1rem 0.5rem;
`;

const ErrorMessage = styled.div`
  color: #d52566;
  background-color: #fff5f7;
  border: 1px solid #ffc2d1;
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin: 1rem 0;
  font-size: 0.875rem;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
`;
